<template>
  <div>
    <!-- 회원 맞춤 추천 -->
    <div class="box">
      <admin-box-item title="회원 맞춤 추천 필터 추가 및 설정"
                      bottomSubtitle="카테고리가 복수일 경우, 관리자는 카테고리별로 다른 필터를 적용하여 유저들에게 맞춤 상품을 추천할 수 있습니다.예) 다이어트 상품 판매 플랫폼의 경우, 식품 추천 필터와 운동 기구 추천 필터를 다르게 설정">

        <div class="flex" style="flex-wrap: wrap">
          <div class="lp-form-type"
               :class="{'selected':selectedRecommendItem.id===item.id}"
               v-for="(item, idx) in value.recommend_set_list" :key="'recm-'+idx"
               @click="clickFormType(item, 'recommend', idx)">
            <input class="input lp-form-type-input"
                   :value="item.name"
                   @input="e => inputLabel(e, 'recommend', item)"
                   type="text"
                   maxlength="15">
            <i class="material-icons lp-form-close"
               @click.stop.prevent="deleteForm('recommend', idx)"
               v-if="selectedRecommendItem.id===item.id">close</i>
          </div>
          <div class="lp-form-add" @click="addRecommendForm">+</div>
        </div>
      </admin-box-item>
    </div>
    <div class="box" v-if="value.recommend_set_list.length > 0">
      <admin-box-item :title="`회원 맞춤 추천 필터: ${selectedRecommendItem.name}`"
                      bottomSubtitle="기본 필터 사용여부를 결정하고 맞춤DB를 새로 생성했는데 필터로도 적용하고 싶을 때 직접 필터를 설정할 수 있습니다."
                      :useTab="false">
        <div slot="header-right-spot">
          <div class="btn-group-justify-end" style="margin:0;position:absolute;top:0;right:0">
            <button class="button small" @click="addCopyForm('recommend')" v-if="value.recommend_set_list.length > 0">복제</button>
          </div>
        </div>

        <draggable :list="value.custom_recommend_set.data" :options="{group:'user', ghostClass:'ghost'}" class="dragArea">
          <div class="columns is-multiline"
               style="margin:0; border-bottom: 1px solid #e5e5e5; padding: 12px 0"
               v-for="(item, idx) in value.custom_recommend_set.data" :key="'recm-user-'+idx"
               v-if="value.custom_recommend_set.data.length > 0">
            <div style="line-height: 5rem; color: #bababa">
              <admin-form-item>
                <i class="material-icons lp-drag-indicator">
                  drag_indicator
                </i>
              </admin-form-item>
            </div>

            <div class="column is-2">
              <admin-form-item label="맞춤 추천에 이용할 회원 DB 항목" tip="추천을 위해 이용할 회원의 DB 항목을 선택합니다.">
                <div>
                  <span class="select">
                    <select :value="mappingParam(item, 'recommend')" @change="e => userMatchingDB(e, item)">
                      <option v-for="(useritem,idx) in userParamList" :key="'useritem-'+idx"
                              :value="mappingParamValue(useritem)">{{ useritem.name }}</option>
                    </select>
                  </span>
                </div>
              </admin-form-item>
            </div>

            <div class="column is-2"></div>

            <div class="column is-3">
              <admin-form-item label="매칭시킬 상품 DB 항목" tip="추천을 위해 이용할 상품의 DB 항목을 선택합니다.">
                <div v-if="item.param_id">
                    <span class="select styled-select">
                      <select v-model="item.param_id" @change="e => recommendProductMatchingDB(e, item)">
                        <option v-for="(dbitem, idx) in prodParamList" :key="'dbitem-'+idx" :value="dbitem.id" v-if="isRecommendTrueType(item, dbitem)">{{ dbitem.name }}</option>
                      </select>
                    </span>
                </div>
                <div v-else>
                      <span class="select styled-select">
                        <select  v-model="item.param_name" @change="e => recommendProductMatchingDB(e, item)">
                          <option v-for="(dbitem, idx) in prodParamList" :key="'dbitem-'+idx" :value="dbitem.name" v-if="isRecommendTrueType(item, dbitem)">{{ dbitem.name }}</option>
                        </select>
                      </span>
                </div>
              </admin-form-item>
            </div>

            <div class="column is-2">
              <admin-form-item label="사용여부">
                <toggle-button @change="e=> item.is_active = e.value"
                               :value="item.is_active"
                               :sync="true"
                               class="changed-font"
                               :width="70"
                               :height="24"></toggle-button>
              </admin-form-item>
            </div>
            <div class="column is-2">
              <admin-form-item>
                <button class="button text-primary small"
                        style="margin-top: 20px"
                        @click="deleteCustomFilterItem(idx, 'recommend')">삭제</button>
              </admin-form-item>
            </div>
          </div>
        </draggable>
        <div class="columns is-multiline"
             style="margin:0">
          <div class="column is-full">
            <span @click="addRecommend" class="add-filter">+ 필터추가하기</span>
          </div>
        </div>
      </admin-box-item>
    </div>
  </div>
</template>
<script>
  import draggable from 'vuedraggable'
  import FilterSettingMixin from "../../../../mixins/FilterSettingMixin";
  import LpImgDropDown from "../../../module/common/LpImgDropDown";

  export default {
    name: "RecommendSettingComp",
    components: {LpImgDropDown, draggable},
    props: {
      value: {
        type: Object
      },
      inputTypeList: {
        type: Array
      },
      prodParamList: {
        type: Array
      }
    },
    mixins: [
      FilterSettingMixin
    ],
    created() {
      this.getUserParamList();
    },
    data() {
      return {
        selectedRecommendItem: {
          id: 0,
          name: ''
        },
        userParamList: [],
      }
    },
    methods: {
      init(){
        if( this.value.recommend_set_list.length>0 ){
          this.selectedRecommendItem.id = this.value.recommend_set_list[0].id;
          this.selectedRecommendItem.name = this.value.recommend_set_list[0].name;
          this.getRecommendSet();
        }
        else {
          this.value.recommend_filter_set = {
            id: 0,
            name: '',
            data: []
          }
          this.value.recommend_set_list = [];
          this.value.recommend_set_list.push(this.selectedRecommendItem);
        }
      },
      // setrecommend detail
      getRecommendSet(){
        if(!this.selectedRecommendItem.id) return;
        this.$axios.get(this.getUrl('service/set/recommend/' + this.selectedRecommendItem.id)).then(res=>{
          if(res.status===200) {
            this.value.custom_recommend_set = res.data;
          }
        })
      },
      addRecommend(){
        let item = {
          label: '',
          keyword: '',
          is_active: false,
          set: [],
          user: {
            // 유저 파람 아이디
            is_param: true,
            param_id: '',
            param_name: '',
            type: '',
          },
          param_id: '',
          param_name:'',
          is_param: true,
          type: '',
        }
        this.value.custom_recommend_set.data.push(item);
      },
      addRecommendForm() {
        if(this.value.recommend_set_list.length===0){
          this.value.custom_recommend_set.data = this.recommendSetData();
        }
        this.value.custom_recommend_set.id = 0;
        this.value.custom_recommend_set.name = '';
        this.value.recommend_set_list.push({ name: '', id: 0 });
      },
      // 데이터 없을 경우 초기값
      recommendSetData() {
        return [
          {
            set: [
              {
                value: "",
                keyword: "address",
                operator: "__sido__name"
              },
              {
                value: "",
                keyword: "address",
                operator: "__sigungu__name"
              }
            ],
            label: "지역",
            is_active: false,
            user: {
              // 유저 파람 아이디
              is_param: false,
              param_id: '',
              param_name: '지역',
              type: 'address',
              keyword: "address",
            },
            param_id: '',
            param_name: '지역',
            is_param: false,
            type: 'address',
            keyword: "address",
          }
        ]
      },
      // 회원 맞춤 DB 목록
      getUserParamList() {
        this.$axios.get(this.getUrl('service/set/userdb/list')).then(res=>{
          if(res.status===200) {
            this.userParamList = res.data;
          }
        })
      },
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-form-type
    border 1px solid #7a7a7a
    border-radius 3px
    cursor pointer
    margin-right 8px
    margin-bottom 2px
    position relative


  .selected
    color $primary
    border 1px solid $primary
    background-color unset

  .lp-form-add
    width 60px
    border 1px solid
    border-radius 3px
    padding 6px 8px
    text-align center
    margin-right 8px
    cursor pointer
    height 33.5px

  .lp-form-type-input
    border 0
    box-shadow unset
    cursor pointer

  .add-filter
    padding 12px 24px
    color $primary
    cursor pointer

  .lp-form-close
    position absolute
    right 2px
    top 5px
    font-size 1.5rem
</style>
